import $ from 'jquery'
import appActions from '../actions/AppActions'
import '../stores/AppStore';

const templateData = $('body').data()

/**
 * Normalize charity name and donation ID strings from template data.
 */
if (templateData.charityName) {
	try {
		templateData.charityName = decodeURIComponent(templateData.charityName);
	} catch (er) {
		templateData.charityName = templateData.charityName;
	}
}
if (templateData.donationId) {
	try {
		templateData.donationId = decodeURIComponent(templateData.donationId);
	} catch (er) {
		templateData.donationId = templateData.donationId;
	}
}

/**
 * Attempting update default value for amount in flux store
 */
appActions.changeAmount({
	amount: templateData.donationAmount.toString()
})

/**
 * Attempting update default value for currency symbol in flux store
 */
appActions.changeSymbol({
	symbol: templateData.donationSymbol
})

/**
 * Attempting update default value for currency code in flux store
 */
appActions.changeCode({
	code: templateData.donationCode
})

/**
 * Attempting update default value for note in flux store
 */
appActions.changeNote({
	note: templateData.donationNote
})

if (templateData.isPresetAmountSelected) {
	appActions.updateDonationAmountType('preset');
}


templateData.enablePresetAmounts = shouldEnablePresetAmounts();
templateData.presetAmounts = templateData.presetAmounts[templateData.charityCountry];

/**
 * Attempting to parse all locals messages from DOM
 */
function parseMessages(templateName) {
	if (!templateName) {
		console.warn('Missing template name');
	}
	try {
		const localsAllMessages = JSON.parse(document.getElementById('localsMessages').innerHTML || {});
		return localsAllMessages[templateName] || localsAllMessages;
	} catch (e) {
		console.warn('Please attach locales to DOM');
		return {}
	}
}

/**
 * Attempting to get all data from template
 */
export default templateData;

/**
 * Attempting to grab all locals messages
 */
export function localsMessages(templateName) {
	return parseMessages(templateName)
}


/**
 * Attempting to grab all locals messages for guest billing page
 */
export function guestLocalsMessages() {

	const pxp = templateData.pxp || {};
	const guestAccCBLabel = pxp.guestCreateAccCB && pxp.guestCreateAccCB.experiment || false;
	const guestMessages = localsMessages('guest/guestForm') || {}
	const guestsignup = guestMessages.guestsignup || {}
	const passwordWarnings = guestMessages.passwordWarnings || {}
	const cpfWarnings = guestMessages.cpfWarnings || {}
	let nationalIds = [];

	try {
		nationalIds = JSON.parse(guestsignup.nationalIds)
	} catch (e) { /* nothing required as nationalIds are only applicable for limited countries */ }
	const createAccountPreProps = {
		mainTitle: '', // guestsignup.mainTitle
		mainBlurb: '', // guestsignup.mainBlurb
		itsFreeLine: '', // guestsignup.itsFreeLine
		mainTitle2: guestsignup.mainTitle2,
		createAccountCheckboxContent: guestsignup.createAccountCheckboxContent,
		createAccountHelp1: guestAccCBLabel ? guestsignup.expcreateAccountHelpContent : guestsignup.createAccountHelpContent,
		createAccountHelp2: guestAccCBLabel ? '' : guestsignup.createAccountHelpContent2,
		label1: guestAccCBLabel ? guestsignup.explabel1 : guestsignup.label1,
		label2: guestAccCBLabel ? guestsignup.explabel2 : guestsignup.label2,
		legalBlurbHTML: guestsignup.legalBlurbHTML,

		labeldob: guestsignup.labeldob,
		labelnationality: guestsignup.labelnationality,
		dobPattern: guestsignup.dobPattern,
		dobHelp: guestsignup.dobPattern && guestsignup.dobPattern.toUpperCase(),
		labelocc: guestsignup.labelocc,
		legalOnlyHTML: guestsignup.legalOnlyHTML,
		consentBlurbHTML: guestsignup.consentBlurbHTML,
		labelNationalIdType: guestsignup.labelNationalIdType,
		labelNationalIdNumber: guestsignup.labelNationalIdNumber,
		nationalIds,
		defaultIdType: 'NATIONAL_ID', // Setting up deafult ID type

		passwordWarnings: {
			_MISMATCH: passwordWarnings.MISMATCH,
			_IS_NULL: passwordWarnings.IS_NULL,
			_TOO_SHORT: passwordWarnings.TOO_SHORT,
			_TOO_LONG: passwordWarnings.TOO_LONG,
			_CONTAINS_REPEATED_CHARACTERS: passwordWarnings.CONTAINS_REPEATED_CHARACTERS,
			_CONTAINS_NUMBER_SEQUENCE: passwordWarnings.CONTAINS_NUMBER_SEQUENCE,
			_CONTAINS_LETTER_SEQUENCE: passwordWarnings.CONTAINS_LETTER_SEQUENCE,
			_CONTAINS_NUMBER_LETTER_SEQUENCE: passwordWarnings.CONTAINS_NUMBER_LETTER_SEQUENCE,
			_IS_BLACKLISTED: passwordWarnings.IS_BLACKLISTED,
			_CONTAINS_SPACES: passwordWarnings.CONTAINS_SPACES,
			_HAS_ILLEGAL_CHARACTERS: passwordWarnings.HAS_ILLEGAL_CHARACTERS,
			_LEGAL_CHECKBOX: passwordWarnings.LEGAL_CHECKBOX,
			_REQUIRED_DOB: passwordWarnings.REQUIRED_DOB,
			_INVALID_DOB: passwordWarnings.INVALID_DOB,
			_MUST_18_DOB: passwordWarnings.MUST_18_DOB,
			_HELP_DOB: passwordWarnings.HELP_DOB,
			_OCCUPATION: passwordWarnings.OCCUPATION,
			_NATIONALITY: passwordWarnings.NATIONALITY,
			_HINT1: passwordWarnings.HINT1,
			_HINT2: passwordWarnings.HINT2,
			_HINT3: passwordWarnings.HINT3,
			_NATIONAL_ID_TYPE: passwordWarnings._NATIONAL_ID_TYPE,
			_NATIONAL_ID_NUMBER: passwordWarnings._NATIONAL_ID_NUMBER,
		}
	}
	const createAccountPost = {
		mainTitle: '', // guestsignup.mainTitle
		mainBlurb: '', // guestsignup.mainBlurb
		itsFreeLine: '', // guestsignup.itsFreeLine
		createAccountCheckboxContent: guestsignup.createAccountCheckboxContent,
		pplogo: guestsignup.pplogo,
		mainTitle1: guestsignup.mainTitle1,
		mainTitle2: guestAccCBLabel ? guestsignup.expmainTitle2 : guestsignup.mainTitle2,
		mainTitle3: guestAccCBLabel ? guestsignup.expmainTitle3 : guestsignup.mainTitle3,
		notNow: guestsignup.notNow,
		label1: guestsignup.label1,
		label2: guestsignup.label2,
		legalBlurbHTML: guestsignup.legalBlurbHTML,

		labeldob: guestsignup.labeldob,
		labelnationality: guestsignup.labelnationality,
		dobPattern: guestsignup.dobPattern,
		labelocc: guestsignup.labelocc,
		legalOnlyHTML: guestsignup.legalOnlyHTML,
		consentBlurbHTML: guestsignup.consentBlurbHTML,

		passwordWarnings: {
			_MISMATCH: passwordWarnings.MISMATCH,
			_IS_NULL: passwordWarnings.IS_NULL,
			_TOO_SHORT: passwordWarnings.TOO_SHORT,
			_TOO_LONG: passwordWarnings.TOO_LONG,
			_CONTAINS_REPEATED_CHARACTERS: passwordWarnings.CONTAINS_REPEATED_CHARACTERS,
			_CONTAINS_NUMBER_SEQUENCE: passwordWarnings.CONTAINS_NUMBER_SEQUENCE,
			_CONTAINS_LETTER_SEQUENCE: passwordWarnings.CONTAINS_LETTER_SEQUENCE,
			_CONTAINS_NUMBER_LETTER_SEQUENCE: passwordWarnings.CONTAINS_NUMBER_LETTER_SEQUENCE,
			_IS_BLACKLISTED: passwordWarnings.IS_BLACKLISTED,
			_CONTAINS_SPACES: passwordWarnings.CONTAINS_SPACES,
			_HAS_ILLEGAL_CHARACTERS: passwordWarnings.HAS_ILLEGAL_CHARACTERS,
			_LEGAL_CHECKBOX: passwordWarnings.LEGAL_CHECKBOX,

			_REQUIRED_DOB: passwordWarnings.REQUIRED_DOB,
			_INVALID_DOB: passwordWarnings.INVALID_DOB,
			_OCCUPATION: passwordWarnings.OCCUPATION,
			_NATIONALITY: passwordWarnings.NATIONALITY,
			_HINT1: passwordWarnings.HINT1,
			_HINT2: passwordWarnings.HINT2,
			_HINT3: passwordWarnings.HINT3,
		},
		buttonText: guestsignup.agreeanddonate
	}

	const cpf = {
		label: guestsignup.cpf,
		warnings: {
			_REQUIRED_CPF: cpfWarnings.REQUIRED_CPF,
			_INVALID_CPF: cpfWarnings.INVALID_CPF,
		}
	}

	return {
		guestMessages: guestMessages,
		guestLabels: guestMessages.label || {},
		guestHelp: guestMessages.help || {},
		guestCaptcha: guestMessages.captcha || {},
		createAccountPreProps: createAccountPreProps,
		createAccountPost: createAccountPost,
		cpf: cpf,
	}
}

function shouldEnablePresetAmounts() {
	return templateData.donationAmountEditable && 
		templateData.pxp.showPresetButtonsExp &&
		templateData.pxp.showPresetButtonsExp.experiment || false;
}




// WEBPACK FOOTER //
// ./utility/getTemplateData.js